import React, { useState } from 'react';
import { Button, DialogContentText } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions, FormLabel } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useTranslation } from 'react-i18next';
import frLocale from 'date-fns/locale/fr-CH';
import ArchiveIcon from '@mui/icons-material/Archive';
import AlertDialog from 'src/shared/sharedModal';
import {  put } from 'src/api/api';
import useStoreGlobalFeedback from 'src/modules/shared/globalFeedback/globalFeedback.store.js';


export default function ArchiveButton({ onClick, disabled }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showArchiveConfirmation, setShowArchiveConfirmation] = React.useState(false);
  const setFeedback = useStoreGlobalFeedback((state) => state.setFeedback);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function archiveIncident() {
    await put('incident/archiveOlderThan', {date: selectedDate});
    setFeedback({ msg: ' ', severity: 'success' });
   // queryClient.setQueryData(['incident', { id: id }], {});
   // history.goBack();
  }

  const handleConfirm = () => {
    console.log(selectedDate);
    if(selectedDate) {
    setShowArchiveConfirmation(true);
    handleClose();
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="contained"
        startIcon={<ArchiveIcon />}
        onClick={handleOpen}
        disabled={disabled}
      >
        {t('ARCHIVE_INCIDENT')}
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t('SELECT_ARCHIVE_DATE')}</DialogTitle>
        <DialogContent>
        
          <DialogContentText id="alert-dialog-description">{t('PLEASE_SELECT_ARCHIVE_DATE_L1')}</DialogContentText>
          <DialogContentText id="alert-dialog-description">{t('PLEASE_SELECT_ARCHIVE_DATE_L2')}</DialogContentText>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
            <DatePicker
              value={selectedDate}
              onChange={setSelectedDate}
              fullWidth
              sx={{ mt: 2 }}
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('CANCEL')}</Button>
          <Button 
            onClick={handleConfirm} 
            variant="contained" 
            color="primary"
          >
            {t('CONFIRM')}
          </Button>
        </DialogActions>
      </Dialog>
      <AlertDialog
    open={showArchiveConfirmation}
    setOpen={setShowArchiveConfirmation}
    Message={t('Êtes-vous sûr de vouloir archiver cette intervention?')}
    onConfirm={() => archiveIncident()}
    AcceptBtn={t('YES')}
    CancelBtn={t('CANCEL')}
  />
    </>
  );
}
